import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

import { Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { DashboardService } from '../../service/dashboard.service'
import { session } from '../../../../environments/environment.session'
import { ComplaintsService } from '../../service/complaints.service'
import { SpinnerService } from '../../../shared/spinner.service'
import Swal from 'sweetalert2';
import { PdfGeneratorService } from '../../service/pdf-generator.service';
import { TranslationService } from '../../service/translation.service';
import { ExcelService } from '../../service/file-export.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  myNumber = 1;
  displayedColumns: string[] = ['id', 'ticket_id', 'department', 'zone', 'fullName', 'mobileNo', 'dateTime', 'days_open', 'status', 'action'];

  selectedZone: string | null = null;
  selectedDept: string | null = null;
  uniqueZones: string[] = [];
  uniqueDepartments: string[] = [];
  allComplaints: any[] = []; // Store raw data

  dataSource = [

  ];

  complaints = new MatTableDataSource<any>([]);
  constructor(private excel: ExcelService, private pdfService: PdfGeneratorService, private dashboardService: DashboardService, private cs: ComplaintsService, private router: Router, public mainService: MainService, private tspinner: SpinnerService, public translation: TranslationService) { }
  erpUser: any
  total_complaints: number = 0
  pending_count: number = 0
  resolved_count: number = 0
  total_escalated: number = 0
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser))
    
    // Custom filter predicate for global search and filters
    this.complaints.filterPredicate = (data: any, filter: string) => {
      const searchStr = filter.trim().toLowerCase();
      
      // Global Search
      const dataStr = Object.keys(data).map(key => {
        if (key === 'departments' && Array.isArray(data[key])) {
           return data[key].map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(' ');
        }
        return data[key];
      }).join(' ').toLowerCase();
      
      const matchesSearch = !this.searchText || dataStr.includes(this.searchText.toLowerCase());

      // Zone Filter
      const matchesZone = !this.selectedZone || (data.zone && data.zone === this.selectedZone);

      // Department Filter
      let deptStr = '';
      if (data.departments && Array.isArray(data.departments)) {
        deptStr = data.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(' ');
      }
      const matchesDept = !this.selectedDept || deptStr.includes(this.selectedDept);

      return matchesSearch && matchesZone && matchesDept;
    }

    this.getcomplaintsDtl()
    this.getComplaints()
  }

  async getcomplaintsDtl() {
    let obj = {
      b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.user_id,
    }
    let resp = await this.dashboardService.getallComplaints(JSON.stringify(obj));

    if (resp['error'] == false) {
      console.log(resp['data'])
      this.total_complaints = resp['data']['total_complaints']
      this.pending_count = resp['data']['pending_complaints']
      this.resolved_count = resp['data']['total_resolved']
      this.total_escalated = resp['data']['total_escalated']

    } else {

    }
  }

  onDownloadPDF(element: any) {
    const b_acct_id = this.erpUser.b_acct_id;
    this.pdfService.generateComplaintPDF(b_acct_id, element.com_id);
  }
  department = {}
  async getComplaints() {

    let obj = { b_acct_id: this.erpUser.b_acct_id, user_id: this.erpUser.le_id };
    this.tspinner.show('', '')
    let resp = await this.cs.getComplaints(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.tspinner.hide()
      this.allComplaints = resp.data.map((complaint: any) => {
        try {
          const deptArray = JSON.parse(complaint.dept || '[]');
          complaint.departments = deptArray.map((item: any) => Object.values(item));
          complaint.deptName = complaint.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(', ');
        } catch (err) {
          complaint.departments = [];
          complaint.deptName = complaint.dept || '';
        }
        return complaint;
      });

      // Extract unique zones and departments
      const zones = new Set<string>();
      const departments = new Set<string>();

      this.allComplaints.forEach(item => {
        if (item.zone) zones.add(item.zone);
        if (item.deptName) departments.add(item.deptName);
      });

      this.uniqueZones = Array.from(zones).sort();
      this.uniqueDepartments = Array.from(departments).sort();

      this.complaints = new MatTableDataSource(this.allComplaints)
      this.complaints.paginator = this.paginator;
      
      // Re-apply custom filter predicate to the new dataSource instance
      this.complaints.filterPredicate = (data: any, filter: string) => {
        // We use the filter string to trigger updates, but actual logic uses component properties
        const matchesSearch = !this.searchText || Object.keys(data).map(key => {
            if (key === 'departments' && Array.isArray(data[key])) {
               return data[key].map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(' ');
            }
            return data[key];
          }).join(' ').toLowerCase().includes(this.searchText.toLowerCase());
  
        const matchesZone = !this.selectedZone || (data.zone && data.zone === this.selectedZone);
        
        let deptStr = data.deptName || '';
        const matchesDept = !this.selectedDept || deptStr.includes(this.selectedDept);
  
        return matchesSearch && matchesZone && matchesDept;
      }
      this.complaints.paginator = this.paginator; // Ensure paginator is linked

      return
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
      return
    }

  }
  searchText: string = '';

  applyFilter() {
    // Trigger filter update. The actual logic is in filterPredicate using searchText, selectedZone, etc.
    this.complaints.filter = 'trigger' + Math.random(); 
    if (this.complaints.paginator) {
      this.complaints.paginator.firstPage();
    }
  }

  exportToExcel() {
    let dataForExport = this.complaints.filteredData.map((row: any) => {
      let departments = '';
      try {
        if (row.departments && Array.isArray(row.departments)) {
          departments = row.departments.map((d: any) => Array.isArray(d) ? d.join(' ') : d.toString()).join(', ');
        } else if (row.dept) {
          const deptArray = JSON.parse(row.dept);
          departments = deptArray.map((item: any) => Object.values(item)).join(', ');
        }
      } catch (e) {
        departments = row.dept || '';
      }

      return {
        [this.translation.t('officerDashboard', 'ticketId')]: row.ticket_id,
        [this.translation.t('officerDashboard', 'department')]: departments,
        [this.translation.t('preview', 'zone')]: row.zone,
        [this.translation.t('officerDashboard', 'fullName')]: row.full_name,
        [this.translation.t('officerDashboard', 'mobileNo')]: row.mobile_no,
        [this.translation.t('officerDashboard', 'createdDate')]: row.create_date,
        [this.translation.t('common', 'daysOpen')]: row.number_of_open_days,
        [this.translation.t('common', 'status')]: row.status
      };
    });
    this.excel.exportAsExcelFile(dataForExport, 'Officer_Complaints');
  }

  exportToPDF() {
    const headings = [
      this.translation.t('export', 'srNo'),
      this.translation.t('officerDashboard', 'ticketId'),
      this.translation.t('officerDashboard', 'department'),
      this.translation.t('preview', 'zone'),
      this.translation.t('officerDashboard', 'fullName'),
      this.translation.t('officerDashboard', 'mobileNo'),
      this.translation.t('officerDashboard', 'createdDate')
    ];
    this.pdfService.generateTablePDF(this.complaints.filteredData, 'Officer Complaints Report', headings);
  }

  route(element: any) {
    this.router.navigate(['/sdp/officer/update-complaints'], {
      state: { data: element }
    });
  }

  route1(element: any) {
    this.router.navigate(['sdp/complaints/preview'], {
      state: { data: element, fromPage: this.router.url }
    });
  }
  ngAfterViewInit(): void {
    this.mainService.dataSource = this.complaints
    // this.complaints.paginator = this.paginator;
  }
  // updateItem(element: any) {
  // console.log('Updating item:', element);
  // this.router.navigate(['/cfc/administration/verifier/complaints-details']);
  // } 
}
